import moment from 'moment';
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CodeName } from "@/store/common";
import { KaihaiHandyImportColRowModel, colKeys, colDataType } from "@/components/kaihai/KaihaiHandyImportTableModel";
import * as editorUtil from "@/util/editorUtil";

export interface RowData {
  beforeSyubaiDate?: string | null,
  beforeJan?: string | null,
  beforeMakerName?: string | null,
  beforeItemName?: string | null,
  beforeKikaku?: string | null,
  beforeIrisu?: string | null,
  beforeJodai?: number | null,
  beforeSyubaiFlg?: boolean | null,
  beforeJyodaiFlg?: boolean | null,
  beforeKikakuFlg?: boolean | null,
  beforeNyusatsuFlg?: boolean | null,
  beforeBikou?: string | null,

  afterHatsubaiDate?: string | null,
  afterJan?: string | null,
  afterMakerName?: string | null,
  afterItemName?: string | null,
  afterKikaku?: string | null,
  afterIrisu?: string | null,
  afterJodai?: number | null,
  afterJanhenFlg?: boolean | null,
  afterBikou?: string | null,

  // //エラー情報
  // errorInfo?:ErrorInfoData,

  // //編集
  // edited?:boolean,
}

//Page State
export type KaihaiImportHandyTmpState = {
  progress: Record<string, unknown>,
  datas: RowData[],
  fixedRowsTop: number,
  rows: any[][],
  mergeCells: { row: number, col: number, rowspan: number, colspan: number }[],

  errorMessage: string | null,
};

export const initialState: KaihaiImportHandyTmpState = {
  progress: {},
  datas: [],
  fixedRowsTop: 0,
  rows: [],
  mergeCells: null,

  errorMessage: null,
};

//Page Slice
export type KaihaiImportHandyTmpReducer = {
  putProgress: (state: KaihaiImportHandyTmpState, action: PayloadAction<string>) => void,
  removeProgress: (state: KaihaiImportHandyTmpState, action: PayloadAction<string>) => void,
  setErrorMessage: (state: KaihaiImportHandyTmpState, action: PayloadAction<string>) => void,
  refreshTableWithFilter: (state: KaihaiImportHandyTmpState, action: PayloadAction<{ colRowModel: KaihaiHandyImportColRowModel, }>) => void,
  refreshTable: (state: KaihaiImportHandyTmpState, action: PayloadAction<{ colRowModel: KaihaiHandyImportColRowModel, }>) => void,
  editRowDatas: (state: KaihaiImportHandyTmpState, action: PayloadAction<{
    editDatas: {
      row: number, col: number, value: string | number | object | null
      , relatedValues?: { key: string, value: string | number | object | null }[]
      , uuid?: string
    }[],
    colRowModel: KaihaiHandyImportColRowModel,
  }>) => void,

  //
  addRow: (state: KaihaiImportHandyTmpState, action: PayloadAction<{ rowCount: number, reset?: boolean }>) => void,
  removeEmptyRow: (state: KaihaiImportHandyTmpState) => void,
}

const createReducerContent = (): KaihaiImportHandyTmpReducer => {
  return {
    putProgress(state: KaihaiImportHandyTmpState, action: PayloadAction<string>) {
      const key = action.payload;
      const progressNew = { ...state.progress };
      progressNew[key] = true;
      state.progress = progressNew;
    },
    removeProgress(state: KaihaiImportHandyTmpState, action: PayloadAction<string>) {
      const key = action.payload;
      const progressNew = {};
      Object.keys(state.progress).forEach(k => {
        if (key != k) {
          progressNew[k] = true;
        }
      })
      state.progress = progressNew;
    },
    setErrorMessage(state: KaihaiImportHandyTmpState, action: PayloadAction<string>) {
      state.errorMessage = action.payload;
    },
    refreshTableWithFilter(state: KaihaiImportHandyTmpState, action: PayloadAction<{
      colRowModel: KaihaiHandyImportColRowModel,
    }>) {
      console.log('refreshTableWithFilter');
      // if (!state.dataGroups || state.dataGroups.length == 0) {
      //   return;
      // }
      // const colRowModel = action.payload.colRowModel;

      // let dataGroups = state.dataGroups;
      // // dataGroups = sortDataGroups(dataGroups);
      // const [rowInfos, fixedRowsTop] = convertRowInfos(dataGroups);
      // //store更新
      // state.dataGroups = dataGroups;
      // state.rowInfos = rowInfos;
      // state.fixedRowsTop = fixedRowsTop;
      // state.mergeCells = createMergeCells(rowInfos, colRowModel);
      // state.rows = convertRows(rowInfos, colRowModel);
    },
    refreshTable(state: KaihaiImportHandyTmpState, action: PayloadAction<{
      colRowModel: KaihaiHandyImportColRowModel,
    }>) {
      console.log('refreshTable');
      // if (!state.dataGroups || state.dataGroups.length == 0) {
      //   return;
      // }
      // const colRowModel = action.payload.colRowModel;

      // let dataGroups = state.dataGroups;
      // // dataGroups = sortDataGroups(dataGroups);
      // const [rowInfos, fixedRowsTop] = convertRowInfos(dataGroups);
      // //store更新
      // state.rowInfos = rowInfos;
      // state.fixedRowsTop = fixedRowsTop;
      // state.mergeCells = createMergeCells(rowInfos, colRowModel);
      // state.rows = convertRows2(rowInfos, colRowModel);
    },
    editRowDatas(state: KaihaiImportHandyTmpState, action: PayloadAction<{
      editDatas: {
        row: number, col: number, value: string | number | object | null
        , relatedValues?: { key: string, value: string | number | object | null }[]
        , uuid?: string
      }[],
      colRowModel: KaihaiHandyImportColRowModel,
    }>) {
      console.log('store.editRowDatas');
      const editDatas = action.payload.editDatas;
      const colRowModel = action.payload.colRowModel;
      const newDatas = [...state.datas];

      const editDataContent = (row: number, col: number, key: string, value: string | number | boolean | object | null) => {
        if (!(row >= 0) || (!key && !(col >= 0))) {
          return;
        }
        if (!key) {
          key = colRowModel.keyFromCol(col);
          if (!key) {
            return;
          }
        }
        if (!(col >= 0)) {
          col = colRowModel.colFromKey(key);
        }
        // const keyInfo = colRowModel.keyInfoFromCol(col);

        //parse
        const dataType = colDataType[key];
        value = editorUtil.parseValue(value, dataType.type,
          dataType.type == 'numeric' ? dataType.numericFormat.pattern :
            dataType.type == 'date' ? dataType.dateFormat :
              null);

        let data = newDatas[row];

        data[key] = value;
        // data = calcData(data);
        // data = checkData(data);

        // newDatas[rowInfo.dataIndex].details = calcDetails(newDatas[rowInfo.dataIndex].details);
        // newDatas[row][col] = value;
      };

      editDatas.forEach((editData) => {
        const key = colRowModel.keyFromCol(editData.col);

        editDataContent(editData.row, editData.col, key, editData.value);


        //関連データの更新
        if (editData.relatedValues) {
          editData.relatedValues.forEach(relatedValue => {
            editDataContent(editData.row, null, relatedValue.key, relatedValue.value);
          })
        }
      })
      const rowInfos = convertRows(newDatas,);
      Object.assign(state, {
        datas: newDatas,
        // rowInfos: rowInfos.rowInfos,
        rows: rowInfos.rows,
        mergeCells: rowInfos.mergeCells,
      });
    },
    addRow(state: KaihaiImportHandyTmpState, action: PayloadAction<{ rowCount: number, reset?: boolean }>) {
      console.log('store.addRow');
      const rowCount = action.payload.rowCount;
      const reset = action.payload.reset;

      let newDatas: RowData[] = [];
      for (let i = 0; i < rowCount; i++) {
        const data: RowData = {};
        newDatas.push(data);
      }

      // const useTeibanAll = state.centersIndex == 0;
      // newDatas = fillDatasDetailsCenter(newDatas, state.centers, useTeibanAll); //センター情報を埋める
      // newDatas = calcDatas(newDatas); //計算項目の計算
      // newDatas = checkDatas(newDatas); //データチェック
      // // newDatas = doSort(newDatas, sort.key, sort.asc, false);  //ソート

      const datas = [...(reset ? [] : state.datas), ...newDatas];

      const rowInfos = convertRows(datas);
      Object.assign(state, {
        datas: datas,
        rows: rowInfos.rows,
        mergeCells: rowInfos.mergeCells,
      });
    },
    removeEmptyRow(state: KaihaiImportHandyTmpState) {
      console.log('store.removeEmptyRow');
      let datas = [...state.datas];
      datas = datas.filter(data => !!data.beforeJan||!!data.afterJan);

      // datas = resetRowNo(datas, null); //列番号の振りなおし

      //0行になる場合は1行足す
      if (datas.length == 0) {
        const rowCount = 1;
        let newDatas: RowData[] = [];
        for (let i = 0; i < rowCount; i++) {
          const data: RowData = {};
          newDatas.push(data);
        }

        // const useTeibanAll = state.centersIndex == 0;
        // newDatas = fillDatasDetailsCenter(newDatas, state.centers, useTeibanAll); //センター情報を埋める
        // newDatas = calcDatas(newDatas); //計算項目の計算
        // newDatas = checkDatas(newDatas); //データチェック
        // newDatas = doSort(newDatas, sort.key, sort.asc, false);  //ソート

        datas = [...datas, ...newDatas];
      }

      // const useTeibanAll = state.centersIndex == 0;
      const rowInfos = convertRows(datas);
      Object.assign(state, {
        datas: datas,
        rows: rowInfos.rows,
        mergeCells: rowInfos.mergeCells,
      });
    },
  }
};

//配列データに変換
const convertRows = (datas: RowData[],): {
  rows: [][],
  mergeCells: { row: number, col: number, rowspan: number, colspan: number }[]
} => {
  console.log('store.convertRows');
  const mergeCells: { row: number, col: number, rowspan: number, colspan: number }[] = [];
  const rows = [];
  datas.forEach((data, index) => {
    const no: string = "" + (index + 1);
    const r = [];
    colKeys.forEach((colKey) => {
      switch (colKey) {
        case 'no':
          r.push(no); //No.
          break;
        default:
          r.push(data[colKey]);
          break;
      }
    });
    rows.push(r);
  });

  return {
    rows: rows,
    mergeCells: mergeCells,
  };
}

export const getOptionLabel = (option: CodeName) => {
  return option && option.name ? (option.code + ' ' + option.name) : "";
}

const createSliceContent = (name: string) => createSlice({
  name: name,
  initialState,
  reducers: createReducerContent(),
});

//Page Slice Export
//KaihaiImportHandyTmp
export const kaihaiImportHandyTmpSlice = createSliceContent("kaihaiImportHandyTmp");
